<template>
  <div class="main-content-container">
    <div class="top-content-container position-relative">
      <b-breadcrumb class="pb-2">
        <b-breadcrumb-item>
          <span
            @click="$router.push({ name: 'Resources' })"
            class="breadcrumb--light font-family-medium text-uppercase"
          >
            Resources
          </span>
        </b-breadcrumb-item>
        <b-breadcrumb-item active>
          <span class="breadcrumb--light font-family-medium text-uppercase">
            Categories
          </span>
        </b-breadcrumb-item>
      </b-breadcrumb>
      <div class="d-flex flex-row justify-content-between">
        <h1 class="font-lg font-family-medium primary-dark content-title">
          Categories
        </h1>
      </div>
    </div>
    <b-dropdown-divider class="mt-4 mb-4 " />
    <b-row
      style="margin-bottom: 10rem"
      class="mt-5 px-0 py-2 mr-3 ml-3 flex-column"
    >
      <!-- Skeleton loader -->
      <b-row v-if="isLoadingCategories" class="">
        <b-col md="3" class="mb-3 px-2" v-for="index in 4" :key="index">
          <b-card class="p-1" style="height:22rem">
            <div
              class="d-flex justify-content-end position-absolute card-icon-container"
            >
              <div class="d-flex">
                <b-skeleton type="avatar" size="4.4rem"></b-skeleton>
              </div>
            </div>
            <div
              class="d-flex mb-4 align-items-center justify-content-between w-100"
            >
              <b-skeleton class="w-25 ml-2 mt-3"></b-skeleton>
            </div>
            <b-skeleton class="mb-3 ml-2 mt-5 w-75"></b-skeleton>
            <b-skeleton class="mb-3 ml-2 w-50"></b-skeleton>
            <b-skeleton class="mb-3 ml-2 w-50"></b-skeleton>
          </b-card>
        </b-col>
      </b-row>
      <!-- End skeleton loader -->

      <b-row
        v-if="categories.length > 0 && !isLoadingCategories"
        class="cards-container"
      >
        <b-col
          md="3"
          class="categories-card-list"
          :id="`card-${index}`"
          v-for="(category, index) in categories"
          :key="category.id"
        >
          <b-card
            @click="viewCategory(index)"
            @mouseenter="showCardHover(category.id)"
            @mouseleave="undoCardHover(category.id)"
            class="category-card"
          >
            <div
              class="d-flex justify-content-end position-absolute card-icon-container"
            >
              
            </div>
            <div
              class="d-flex align-items-center justify-content-between w-100" :style="{paddingBottom: '14px'}"
            >
              <p class="primary--text font-size-sm font-family-medium">
                {{ category.title }}
              </p>
            </div>
            <div class="d-flex flex-wrap description-wrapper">
              <p
                class="primary--text description"
              >
                {{ ellipsify(category.description, 80) }}
              </p>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <div
        v-if="!isLoadingCategories && categories.length === 0"
        class="no-assigned-msg pr-5 pt-5 pb-5 pl-2 d-flex flex-column justify-content-center align-items-center"
      >
        <h4 class="font-md primary--text font-family-medium">
          No categories found.
        </h4>
      </div>
      <b-avatar
        size="4.8rem"
        button
        v-if="role === 'admin'"
        @click="showAddCategoryScreen"
        data-cy="category-button-add"
        class="floating-action-btn btn-danger mb-5 position-fixed cursor-pointer"
      >
        <img src="@/assets/icons/floating_plus.svg" alt="" />
      </b-avatar>
    </b-row>

    
    <b-modal
      centered
      class="modal-padding"
      hide-footer
      v-model="errorModal.visible"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-container fluid>
        <b-button
          @click="errorModal.visible = false"
          class="d-flex position-absolute error-modal-close-btn"
        >
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
        <b-row align-v="center" class="px-2 py-2">
          <b-col md="9" class="d-flex mb-2">
            <h4 class="font-md font-family-medium mt-2">
              {{ errorModal.message }}
            </h4>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>

    <b-modal
      id="category-exists-modal"
      v-model="categoryExistsModal.visible"
      body-class="delete-category-modal-body"
      hide-header
      hide-footer
      centered
    >
      <h1>Category already exists.</h1>
      <h3>Kindly update the category details from the categories list.</h3>
      <div class="buttons-row">
        <div class="buttons-wrapper">
          <div class="button-wrapper">
            <b-button 
            data-cy="category-exists-button-cancel"
            class="cancel-button" 
            @click="categoryExistsModal.visible = false"
            >
              Okay
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  deleteCategory,
  getCategories,
  patchCategory,
  patchCheckList,
  postAttachments,
  postCategory,
  deleteCheckList,
  postCategoryAttachment,
  postCheckList,
  deleteCategoryAttachment,
  deleteChecklistOption
} from "@/apis/common/index";
import { isFile, getFileExtension, isImage, isAdmin, ellipsify } from "@/utils/utils";
export default {
  name: "CategoryList",
  components: {
  },
  data() {
    return {
      errorModal: {
        visible: false,
        message: "File is empty. Cannot upload"
      },
      URL: window.URL,
      previewModal: {
        visible: false,
        src: "",
        attachment: null
      },
      categoryExistsModal: {
        visible: false
      },
      message: "",
      sizeExceed: false,
      disableFields: false,
      expandHover: false,
      activeExpandHoverId: "",
      inactiveExpandHoverId: "",
      showInactiveExpandHover: true,
      attachments: [],
      checklist: [],
      add: false,
      view: false,
      checklistValue: "",
      categoryName: "",
      categoryDescription: "",
      fileURL: [],
      showValidity: false,
      showError: false,
      categories: [],
      attachmentIds: [],
      categoryID: "",
      patchORpost: false,
      checklistID: "",
      totalApiCalls: [],
      error: "Some error occured",
      passedApiCalls: [],
      saveLoader: false,
      attachmentDeleteLoader: false,
      deleteCheckListLoader: false,
      viewLoading: true,
      isLoading: false,
      isLoadingCategories: true,
    };
  },
  mounted() {
    if (this.$route.params.add === true) {
      this.add = true;
    }
    if(this.$route.params.categoryExists === true) {
      this.categoryExistsModal.visible=true
    }
    this.fetchCategoryList();
  },
  computed: {
    previewModalData() {
      let { previewModal } = this;
      if (!previewModal.attachment) {
        return {
          src: "",
          title: "",
          thumbnail: ""
        };
      }
      if (previewModal.attachment instanceof File) {
        let blobUrl = window.URL.createObjectURL(previewModal.attachment);
        return {
          src: blobUrl,
          title: previewModal.attachment.name,
          thumbnail: blobUrl
        };
      }
      return {
        src: previewModal.attachment.attachment.attachmentFile,
        title: previewModal.attachment.attachment.filename,
        thumbnail: previewModal.attachment.attachment.thumbnail
      };
    },
    ...mapState("authModule", ["role", "profileUserId"])
  },
  methods: {
    isFile,
    isAdmin,
    getFileExtension,
    isImage,
    ellipsify,

    showCardHover(id) {
      this.activeExpandHoverId = id;
      this.expandHover = true;
      this.showInactiveExpandHover = true;
    },
    undoCardHover(id) {
      this.inactiveExpandHoverId = id;
      this.expandHover = false;
    },
    fetchCategoryList() {
      getCategories()
        .then(res => {
          this.categories = [...res.data.results];
        })
        .catch(err => {
          console.log(err);
          this.isLoadingCategories = false;
        })
        .finally(() => {
          this.isLoadingCategories = false;
        });
    },
    viewCategory(index) {
      this.$router.push({
        name: "ViewCategory",
        params: {
          id: this.categories[index].id
        }
      });
      return;
    },

    fileChange(event) {
      this.sizeExceed = false;
      let sizing = true;
      for (let i = 0; i < event.target.files.length; i++) {
        if (event.target.files[i].size / 1024 / 1024 > 500) {
          sizing = false;
          break;
        }
      }
      // empty file validation
      for (let file of event.target.files) {
        if (file.size === 0) {
          this.errorModal.message = `${file.name} is empty. Cannot upload.`;
          this.errorModal.visible = true;
          let { fileInput1, fileInput2 } = this.$refs;
          // the if checks are necessary because if refs won't exist until
          // a sidebar is opened (mounted onto the DOM)
          if (fileInput1) {
            this.$refs.fileInput1.value = "";
          }
          if (fileInput2) {
            this.$refs.fileInput2.value = "";
          }
          return;
        }
      }
      if (sizing) {
        for (let i = 0; i < event.target.files.length; i++) {
          this.attachments.push(event.target.files[i]);
          this.attachments[i].loader = false;
        }
      } else {
        this.sizeExceed = true;
      }
      let { fileInput1, fileInput2 } = this.$refs;
      // the if checks are necessary because if refs won't exist until
      // a sidebar is opened (mounted onto the DOM)
      if (fileInput1) {
        this.$refs.fileInput1.value = "";
      }
      if (fileInput2) {
        this.$refs.fileInput2.value = "";
      }
    },
    deleteCat() {
      deleteCategory(this.categoryID)
        .then(() => {
          this.categories = this.categories.filter(
            category => category.id !== this.categoryID
          );
          this.closeView();
        })
        .catch(err => {
          console.log(err);
        });
    },
    deleteList() {
      this.deleteCheckListLoader = true;
      deleteCheckList(this.categoryID, this.checklistID)
        .then(() => {
          this.deleteCheckListLoader = false;
          this.checklist.splice(0, this.checklist.length);
          this.patchORpost = false;
        })
        .catch(err => {
          console.log(err);
          this.deleteCheckListLoader = false;
        });
    },
    deleteCategoryAttachment(index) {
      let attachment = this.attachments[index];
      if (attachment instanceof File) {
        this.attachments.splice(index, 1);
      } else {
        attachment.loader = true;
        deleteCategoryAttachment(this.categoryID, this.attachments[index].id)
          .then(() => {
            this.attachments.splice(index, 1);
            if (this.attachments.length > 0) {
              this.attachments[index].loader = false;
            }
          })
          .catch(err => {
            console.log(err);
            if (this.attachments.length > 0) {
              this.attachments[index].loader = false;
            }
          });
      }
    },
    async addCategory() {
      this.showError = false;
      this.showValidity = false;
      const valid = await this.$refs.addCategory.validate();
      if (valid) {
        this.totalApiCalls = [];
        this.passedApiCalls = [];
        this.saveLoader = true;
        const data = {
          title: this.categoryName,
          description: this.categoryDescription
        };
        this.isLoading = true;
        postCategory(data)
          .then(res => {
            const catID = res.data.id;
            this.saveLoader = false;
            this.fetchCategoryList();
            const checklistOptions = [];
            for (let i = 0; i < this.checklist.length; i++) {
              checklistOptions.push({ title: this.checklist[i] });
            }
            const data = {
              title:
                this.categoryName.length < 190
                  ? `${this.categoryName} checklist`
                  : `${this.categoryName.substring(0, 150)} checklist`,
              options: checklistOptions
            };
            this.passedApiCalls.push(true);
            this.saveLoader = true;
            if (data.options.length > 0) {
              postCheckList(res.data.id, data)
                .then(() => {
                  this.passedApiCalls.push(true);
                  this.fetchCategoryList();
                  this.saveLoader = false;
                })
                .catch(err => {
                  console.log(err);
                  this.showError = true;
                  this.saveLoader = false;
                })
                .finally(() => {
                  this.totalApiCalls.push(true);
                  this.saveLoader = false;
                });
            }
            for (let j = 0; j < this.attachments.length; j++) {
              this.saveLoader = true;
              let myFile = new File(
                [this.attachments[j]],
                `${this.attachments[j].name}`
              );
              const formData = new FormData();
              formData.append("owner", this.profileUserId);
              formData.append("attachmentFile", myFile);
              postAttachments(formData)
                .then(res => {
                  const data = {
                    category: catID,
                    attachment: res.data.id
                  };
                  postCategoryAttachment(catID, data)
                    .then(res => {
                      this.attachmentIds.push(res.data.id);
                      if (
                        this.attachmentIds.length === this.attachments.length
                      ) {
                        this.saveLoader = false;
                        this.fetchCategoryList();
                      }
                    })
                    .catch(err => console.log(err));
                })
                .catch(err => {
                  console.log(err);
                  this.error = "some error occured";
                  this.saveLoader = false;
                })
                .finally(() => {
                  this.totalApiCalls.push(true);
                  this.saveLoader = false;
                });
            }
            this.saveLoader = false;
            this.disableFields = true;
            this.showValidity = true;
            this.message = "Details saved successfully";
          })
          .catch(res => {
            this.saveLoader = false;
            this.showError = true;
            if (res.response.status === 401) {
              this.error = "User token expired. Please logout and login again.";
            } else if (res.response.data.title.length > 0) {
              this.error = "Category name already exists";
            } else {
              this.error = "Some error occured";
            }
          })
          .finally(() => {
            this.totalApiCalls.push(true);
            this.isLoading = false;
          });
      } else {
        this.showValidity = true;
        this.message = "There are invalid form fields";
      }
    },
    saveDone() {
      if (this.passedApiCalls.length === 3) {
        this.saveLoader = false;
      }
    },
    async patchData() {
      this.showValidity = false;
      this.showError = false;
      const valid = await this.$refs.editCategory.validate();
      if (valid) {
        this.saveLoader = true;
        const data = {
          title: this.categoryName,
          description: this.categoryDescription
        };
        this.isLoading = true;
        patchCategory(this.categoryID, data)
          .then(() => {
            this.saveLoader = false;
            for (let j = 0; j < this.attachments.length; j++) {
              if (!this.attachments[j].attachment) {
                let myFile = new File(
                  [this.attachments[j]],
                  `${this.attachments[j].name}`
                );
                const formData = new FormData();
                formData.append("owner", this.profileUserId);
                formData.append("attachmentFile", myFile);
                postAttachments(formData)
                  .then(res => {
                    const data = {
                      category: this.categoryID,
                      attachment: res.data.id
                    };
                    postCategoryAttachment(this.categoryID, data).then(res => {
                      this.attachmentIds.push(res.data.id);
                    });
                  })
                  .catch(err => {
                    this.showError = false;
                    console.log(err);
                    this.saveLoader = false;
                  })
                  .finally(() => {
                    this.totalApiCalls.push(true);
                    this.saveLoader = false;
                  });
              }
            }
            if (!this.patchORpost) {
              const checklistOptions = [];
              for (let i = 0; i < this.checklist.length; i++) {
                checklistOptions.push({ title: this.checklist[i] });
              }
              const data = {
                title: `${this.categoryName} checklist`,
                options: checklistOptions
              };
              postCheckList(this.categoryID, data)
                .then(() => {
                  this.patchORpost = false;
                })
                .catch(err => console.log(err))
                .finally(() => {
                  this.totalApiCalls.push(true);
                  this.saveLoader = false;
                });
            } else {
              const checklistOptions = [];
              for (let k = 0; k < this.checklist.length; k++) {
                if (!this.checklist[k].id) {
                  checklistOptions.push({ title: this.checklist[k] });
                } else {
                  checklistOptions.push(this.checklist[k]);
                }
              }
              const data = {
                title: `${this.categoryName} checklist`,
                category: this.categoryID,
                options: checklistOptions
              };
              patchCheckList(this.categoryID, this.checklistID, data)
                .then(() => {
                  this.patchORpost = false;
                })
                .catch(err => console.log(err));
            }
            this.saveLoader = false;
            this.disableFields = true;
            this.showValidity = true;
            this.message = "Details saved successfully";
            // this.closeView();
          })
          .catch(err => {
            this.showError = true;
            if (err.response.status === 401) {
              this.error = "User token expired. Please logout and login again.";
            } else if (err.response.data.title.length > 0) {
              this.error = "Category name already exists";
            } else {
              this.error = "Some error occured";
            }
            this.saveLoader = false;
          })
          .finally(() => {
            this.totalApiCalls.push(true);
            this.fetchCategoryList();
            this.isLoading = false;
          });
      } else {
        this.showValidity = true;
        this.message = "There are invalid form fields";
      }
    },
    resetForm() {
      this.showValidity = false;
      this.checklistValue = "";
      this.categoryName = "";
      this.categoryDescription = "";
      this.checklist = [];
      this.attachments = [];
      this.showError = false;
      this.sizeExceed = false;
    },
    showAddCategoryScreen() {
      this.$router.push({
        name: "AddCategory"
      });
    },
    closeAdd() {
      this.add = false;
      this.resetForm();
    },
    closeView() {
      this.view = false;
      this.resetForm();
    },
    deleteAttachment(index) {
      this.attachments.splice(index, 1);
    },
    createCheck() {
      if (this.checklistValue !== "") {
        this.checklist.push(this.checklistValue);
        this.checklistValue = "";
      }
    },
    deleteCheckListValue(index) {
      if (!this.disableFields) {
        const data = [
          {
            id: this.checklist[index].id
          }
        ];
        if (this.checklist.length > 1) {
          deleteChecklistOption(this.categoryID, this.checklistID, data)
            .then(() => {
              this.checklist.splice(index, 1);
            })
            .catch(err => console.log(err));
        } else {
          deleteCheckList(this.categoryID, this.checklistID)
            .then(() => {
              this.checklist = [];
              this.patchORpost = false;
            })
            .catch(() => {});
        }
      }
    },
    removeChecklistValue(index) {
      if (!this.disableFields) {
        this.checklist.splice(index, 1);
      }
    },
    deleteChecklistOne() {
      deleteCheckList(this.categoryID, this.checklistID)
        .then(() => {
          this.checklist = [];
          this.patchORpost = false;
        })
        .catch(() => {});
    },
    onPreviewModalDownload() {
      // forcibly download the file
      this.$refs.downloadAnchor.click();
    },
    onThumbnailClick(attachment, attachmentIndex) {
      this.previewModal.attachment = attachment;
      this.previewModal.attachmentIndex = attachmentIndex;
      this.previewModal.visible = true;
    },
    onDeleteImage() {
      let { attachmentIndex } = this.previewModal;
      this.deleteCategoryAttachment(attachmentIndex);
      this.previewModal.visible = false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/scss/variables/colors.scss";

.sidebar-title {
  margin-top: 2rem;
}
.checklist-title {
  bottom: 0.7rem;
}
.add-category-alert {
  max-width: 100%;
}
button.btn.close-btn {
  left: -5.5%;
  top: 3rem;
  background: none;
}
.delete-btn {
  margin-right: 3rem;
  margin-top: 2.5rem;
  height: 3rem;
  width: 3rem;
  background: $danger 0% 0% no-repeat padding-box;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    flex: 1;
  }
}
.close-icon {
  width: 3rem;
  height: 3rem;
}
.delete-icon {
  width: 1.5rem;
  height: 1.5rem;
  background: transparent;
}
.nav-search-icon-container {
  right: 1rem;
  top: 1.2rem;
}
.nav-search-icon-container1 {
  right: 1rem;
  top: 1rem;
}
.checklist-container {
  border: 1px solid #dcebf4;
  border-radius: 4px;
  box-sizing: border-box;
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.card-icon-container {
  right: 1rem;
  top: 1rem;
}
.floating-action-btn {
  right: 3rem;
  z-index: 2;
  bottom: 0;
}
button.btn.error-modal-close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
.attachments-row {
  padding: 0 0rem 0 2rem;
  .box-container {
    width: 33%;
  }
}
.description-wrapper {
  font-weight: normal;
  p {
    line-height: 1.5;
    margin: 0;
  }
}
.cards-container {
  border: 1px solid $default-border;
  background-color: $card-container-background;
  border-radius: 6px;
}
.cards-container, .categories-card-list {
  padding: 2.5px;
}
.category-card {
  min-height: 127px;
  height: 100%;
  padding: 14px 10px;
  cursor: pointer;
  .card-body {
    padding: 0;
  }
  p {
    margin: 0;
    line-height: normal;
  }
  .description {
    line-height: 1.5;
  }
}
</style>
